module.exports = __webpack_public_path__ + "img/fb395ae.webp";